import { useLocation } from 'react-router';
import { css } from '@emotion/react';
import { SideBar, SidebarLink, SideMenuHeader } from './side-bar-utils';
import { useMetaSelector } from '../../meta/reducer';
import { FeatureFlagNames } from '@birdi/js-sdk/src/public/organisation-features';
import GeneralSVG from '@birdi/icons/menu-general.svg';
import UsersSVG from '@birdi/icons/menu-users.svg';
import WorkspacesSVG from '@birdi/icons/menu-workspaces.svg';
import BillingSVG from '@birdi/icons/menu-billing.svg';
import PlanSVG from '@birdi/icons/menu-plan.svg';
import ProcessingSVG from '@birdi/icons/menu-processing.svg';
import DroneSVG from '@birdi/icons/drone.svg';
import BottomSection from './bottom-section';
import { UpgradeIndicator } from '@birdi/components-common';

const SideNavigationAdmin = () => {
  const location = useLocation();
  const meta = useMetaSelector();
  const isPrimaryOrg = !meta.workspace;

  const isOrganisationAdmin = meta.permissions.includes(
    'organisation:user:create',
  );
  const isWorkspaceAdmin = meta.permissions.includes('workspace:user:create');
  const canEditWorkspace =
    meta.permissions.includes('workspace:edit') &&
    meta.features.includes('add-workspaces');

  const workspaceEnable = isPrimaryOrg && isWorkspaceAdmin;

  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <SideBar>
        <SideMenuHeader label="Administration" id="administration" />
        <SidebarLink
          to="/admin-general"
          match={location.pathname}
          disabled={!meta.permissions.includes('workspace:edit')}
        >
          <GeneralSVG />
          <span>General</span>
        </SidebarLink>
        <SidebarLink
          to="/admin-users"
          match={location.pathname}
          disabled={!isWorkspaceAdmin}
        >
          <UsersSVG />
          <span>Users</span>
        </SidebarLink>
        {workspaceEnable && (
          <SidebarLink
            to="/admin-workspaces"
            match={location.pathname}
            disabled={!canEditWorkspace}
          >
            <WorkspacesSVG />
            <div
              css={css`
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 0.5em;
              `}
            >
              <span>Workspaces</span>{' '}
              {!canEditWorkspace && (
                <UpgradeIndicator message="Upgrade to add workspaces" />
              )}
            </div>
          </SidebarLink>
        )}
        {isOrganisationAdmin && isPrimaryOrg && (
          <SidebarLink to="/admin-billing" match={location.pathname}>
            <BillingSVG />
            <span>Billing</span>
          </SidebarLink>
        )}
        {/* {(isOrganisationAdmin && isPrimaryOrg) && (
          <SidebarLink
            to="/admin-billing-v2"
            match={location.pathname}
          >
            <BillingSVG />
            <span>Billing v2</span>
          </SidebarLink>
        )} */}
        {/* {(isOrganisationAdmin && isPrimaryOrg) && (
          <SidebarLink
            to="/admin-plan"
            match={location.pathname}
          >
            <PlanSVG />
            <span>Plan & usage</span>
          </SidebarLink>
        )} */}
        {isOrganisationAdmin && isPrimaryOrg && (
          <SidebarLink to="/admin-plan" match={location.pathname}>
            <PlanSVG />
            <span>Plan & usage</span>
          </SidebarLink>
        )}
        <SidebarLink
          to="/admin-processing"
          match={location.pathname}
          disabled={!isOrganisationAdmin}
        >
          <ProcessingSVG />
          <span>Processing</span>
        </SidebarLink>
        {isPrimaryOrg && (
          <SidebarLink
            to="/admin-integrations"
            match={location.pathname}
            disabled={!meta.permissions.includes('organisation:admin')}
          >
            <DroneSVG />
            <span>Integrations</span>
          </SidebarLink>
        )}
        <div
          css={css`
            height: 7em;
          `}
        />
      </SideBar>
      <BottomSection />
    </div>
  );
};

export default SideNavigationAdmin;
